/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlanDetailsDialog } from "@flick/plan_chooser";
import {
  CONTENT_SLUG_TO_THEME_MAPPINGS,
  EXCLUSIVE,
  INCLUSIVE,
} from "domain/configuration";
import {
  FormattedBillEstimate,
  Product,
  ProductForDialog,
} from "domain/core/types";
import React, { useRef } from "react";

import QuestionAndAnswer from "./QuestionAndAnswer";
import RichText from "./RichText";
interface Props {
  product: ProductForDialog;
  billEstimate: FormattedBillEstimate;
  region?: string;
  currentProduct: Product;
}

const ProductDialog = (props: Props) => {
  const { product, billEstimate, region, currentProduct } = props;
  const planDetailsDialogRef = useRef<any>();
  const showDialog = () => planDetailsDialogRef.current.show();

  const pricingDetailsContent =
    product.pricingDetailsContentCollection.items.map(
      (component: any, index) => {
        if (component.__typename === "QuestionAndAnswer") {
          return (
            <QuestionAndAnswer
              data={component}
              key={`${index}-${component.__typename}`}
            />
          );
        }
        return (
          <RichText
            key={`${index}-${component.__typename}`}
            data={component?.content}
          />
        );
      },
    );
  return (
    <>
      <button
        className="button button_secondary--small"
        onClick={showDialog}
        type="button"
      >
        Pricing & plan details <span className="a11y"> for {product.name}</span>
      </button>
      <PlanDetailsDialog
        planName={product.slug}
        title={product.title}
        theme={CONTENT_SLUG_TO_THEME_MAPPINGS[currentProduct]}
        dialogRef={planDetailsDialogRef}
        pricingDetailsContent={pricingDetailsContent}
        billEstimate={billEstimate}
        userType={billEstimate.usageType}
        region={region}
        gstInclusion={product.slug === "business" ? EXCLUSIVE : INCLUSIVE}
      />
    </>
  );
};

export default ProductDialog;
